import { render, staticRenderFns } from "./acknowledge-form.vue?vue&type=template&id=8e6e1a4a&"
import script from "./acknowledge-form.vue?vue&type=script&lang=js&"
export * from "./acknowledge-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports